/*
 * TODO: Refactor this file to fit standards.
*/

const $ = jQuery;

// One Off JS Animations
////////////////////

// Used by Backoffice Login Dropdown
var animations = {

  easedAnchorScroll: function(this_obj, that_obj, base_speed, offset) {
    var this_offset = this_obj.offset();
    var that_offset = that_obj.offset();
    var offset_diff = Math.abs(that_offset.top - this_offset.top );
    var speed       = Math.min((offset_diff * base_speed) / 500, 2000);

    $("html,body").animate({
      scrollTop: that_offset.top - offset
    }, speed);
  },

  wiggle: function() {
    window.wiggleElem = function (target) {
      $(target).addClass('animated shake has-error');
      $(target).one('webkitAnimationEnd mozAnimationEnd oAnimationEnd animationEnd', function() {
        $(this).removeClass('animated shake has-error');
      });
    }
  },

  fadeDown: function(elem) {
    elem.css({
      opacity: 0,
      position: 'relative',
      bottom: 20
    }).queue(function() {
      elem.animate({
        opacity: 1,
        bottom: 0
      }).delay(500);
      $(this).dequeue();
    });
  }
};

module.exports = animations;
